import { AppRecord } from "../types"
import { GetAppsResponse } from "./getApps"

/** Takes list of app records and response of getApps query and returns the app records with icons injected */
const injectAppIcons = (app_records: AppRecord[], apps: GetAppsResponse[]): AppRecord[] => {
  return app_records.map((app) => {
    const app_details = apps.find((a) => a.packageName === app.package_name)

    if (app_details && app_details.icon) {
      return {
        ...app,
        icon: app_details.icon,
      }
    }

    return app
  })
}

export default injectAppIcons
